module.exports = __webpack_public_path__ + "static/img/produto_g.c1abe3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/agua-coco/produto_g.png
// module id = 5tYR
// module chunks = 0